import React from 'react';
import { Link } from 'raviger';
import { Col, Dropdown, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

const ActionsDropdown = ({
  className = '',
  children,
  id = 'actions-dropdown',
  size = 'sm',
  title = 'Actions',
  variant = 'dark',
  search = false,
  style = {color:"white"}
}) => {
  return (
    <Dropdown size={size} className={className} style={style}>
      <Dropdown.Toggle variant={variant ? variant : 'secondary'} className={search ? 'border rounded ' : ''} id={id} style={style}>
        <span>{title}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {React.Children.map(children, (child, index) => (
          <OverlayTrigger
            key={index}
            placement="left"
            overlay={
              <Tooltip id={`tooltip-disabled`} hidden={!(child && child.props && child.props.disabled)}>
                {child && child.props && child.props.disabled_text ? child.props.disabled_text : ''}
              </Tooltip>
            }
          >
            <span style={{cursor:child && child.props && child.props.disabled ? 'not-allowed': 'pointer'}}>
              <Dropdown.Item as="div" className={"pt-0 pb-0 ps-0 pe-3 " + (child && child.props && child.props.disabled ? "border-bottom" : "")} disabled={child && child.props && child.props.disabled ? true : false}>
                <Row className="ms-0 flex-nowrap">
                  <Col className="d-flex justify-content-center p-0" style={{width:"30px", maxWidth:"30px"}}>{child}</Col>
                  <Col className="d-flex p-0 me-1">{child && child.props && child.props.href ?
                    <Link href={child.props.href}>{child && child.props && child.props.label ? child.props.label : ""}</Link>
                    :
                    <span onClick={() => child && child.props && child.props.printFunc ? child.props.printFunc() : child.props.onClick ? child.props.onClick() : null}>{child && child.props && child.props.label ? child.props.label : ""}</span>}
                  </Col>
                </Row>
              </Dropdown.Item>
            </span>
          </OverlayTrigger>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ActionsDropdown;
